import React, { useEffect } from "react";
import styled from "styled-components";
import Button from "~/components-shared/Button";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { RoutesEnum, StatusStateEnum } from "~/types/enums";
import Modal from "~/components-shared/Modal";
import RoleForm from "~/forms/RoleForm";
import roleSchema from "~/forms/RoleForm/roleSchema";
import toastsActionCreators from "~/store/toasts/actions";
import { useHistory } from "react-router-dom";
import { Alert } from "~/components-shared";
import manageCompaniesActionCreators from "~/store/manageCompanies/actions";
import manageCompanySelectors from "~/store/manageCompanies/selectors";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
`;
const ManageCompanyRoleCreateModal = () => {
  const {
    t
  } = useTranslation();
  const action = useSelector(manageCompanySelectors.getAction);
  const company = useSelector(manageCompanySelectors.getSelected);
  const companyId = company?.id || "";
  const status = useSelector(manageCompanySelectors.getStatusByCompany(companyId));
  const error = useSelector(manageCompanySelectors.getErrorByCompany(companyId));
  const dispatch = useDispatch();
  const history = useHistory();
  const defaultValues = {
    name: "",
    description: "",
    weight: 0,
    authorities: []
  };
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    watch
  } = useForm({
    resolver: yupResolver(roleSchema),
    defaultValues
  });
  useEffect(() => {
    if (!action) {
      reset(defaultValues);
    }
  }, [action]);
  const onSubmit = handleSubmit(data => {
    dispatch(manageCompaniesActionCreators.createRoleStarted(companyId, data, _ref => {
      let {
        data: newRole
      } = _ref;
      if (newRole) {
        dispatch(toastsActionCreators.pushed({
          severity: "success",
          message: t("RoleCreateModal.roleCreated", {
            name: newRole.name
          }),
          timeout: 10000,
          actions: [{
            icon: "external-link",
            onClick: () => history.push(RoutesEnum.ROLE_MANAGEMENT.replace(":roleId", newRole.id))
          }]
        }));
        reset(defaultValues);
      }
    }));
  });
  const onCancel = () => {
    dispatch(manageCompaniesActionCreators.actionChanged(null, null));
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("RoleCreateModal.createRole"),
    onClose: onCancel,
    maxWidth: "560px",
    fullWidth: true,
    fullHeight: true
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(RoleForm, {
    control: control,
    setValue: setValue,
    watch: watch,
    authorities: company?.authorities || []
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: onCancel,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    s: {
      ml: 2
    },
    loading: status === StatusStateEnum.LOADING,
    fullWidth: true,
    rounded: true
  }, t("RoleCreateModal.saveRole")))));
};
export default ManageCompanyRoleCreateModal;